module.exports = __webpack_public_path__ + "img/loading.1cf54ce1.gif";